import React from 'react';
import PropTypes from 'prop-types';
import CollapsibleSection from '@zocdoc/components/src/CollapsibleSection';
import { injectIntl } from 'react-intl';
import { noop } from 'lodash';
import FullLanguageSet from './Full';
import PartialLanguageSet from './Partial';
import { LOCALIZED_STRINGS, DEFAULT, SPANISH } from './constants';

class BaseLanguages extends React.Component {
    static propTypes = {
        languageId: PropTypes.string.isRequired,
        defaultOpen: PropTypes.bool,
        numApplied: PropTypes.number,
        onChangeCallback: PropTypes.func.isRequired,
        trackFilterClickLanguage: PropTypes.func,
    };

    static defaultProps = {
        trackFilterClickLanguage: noop,
    };

    constructor(props) {
        super(props);
        this.state = {
            showFullLanguages: props.languageId !== DEFAULT && props.languageId !== SPANISH,
        };
    }

    render() {
        const {
            defaultOpen,
            intl,
            numApplied,
        } = this.props;

        const title = intl.formatMessage(LOCALIZED_STRINGS.Title, {
            count: numApplied,
        });

        return (
            <CollapsibleSection
                data-test="search-refine-language-filter"
                defaultOpen={defaultOpen}
                headerText={title}
            >
                {this.state.showFullLanguages
                    ? (
                        <FullLanguageSet
                            {...this.props}
                            onChangeCallback={this.handleChange}
                        />
                    )
                    : (
                        <PartialLanguageSet
                            {...this.props}
                            onChangeCallback={this.handleChange}
                            seeMoreCallback={this.handleSeeMore}
                        />
                    )}
            </CollapsibleSection>
        );
    }

    handleChange = update => {
        const { languageId } = update;
        this.props.trackFilterClickLanguage(languageId);
        this.props.onChangeCallback(update);
    }

    handleSeeMore = () => this.setState(prevState => ({ showFullLanguages: !prevState.showFullLanguages }))
}

export default injectIntl(BaseLanguages);
